<template>
  <div>
    <div class="main-content">
      <div class="item-box" v-for="(i,index) in dataList" :key="index">
        <div class="msg-line-left">
          <img class="school-badge" :src="i.slogo || require('@/assets/image/default-img.svg')" alt="" />
          <span class="school-name">{{ i.sname }}</span>
          <div class="line-right">
            <span class="product-name">{{ i.versionName ? i.productName + '·' + i.versionName : i.productName }}</span>
            <!-- 试用/订购/赠送/后付款+过期天数 -->
            <el-tooltip placement="top" :open-delay="500" v-if="i.status === 2 && ([0, 1, 5, 6].indexOf(i.orderType) > -1)">
                <div slot="content">{{ i.endDay }}到期，{{i.statusStr}}{{ i.days }}天</div>
                <span class="flag flag-red">{{ i.orderTypeStr }}({{i.statusStr}})</span>
            </el-tooltip>
            <!-- 试用/订购/赠送/后付款+即将到期 -->
            <el-tooltip placement="top" :open-delay="500" v-else-if="i.status === 1 && ([0, 1, 5, 6].indexOf(i.orderType) > -1)">
                <div slot="content">{{ i.endDay }}{{i.statusStr}}剩余{{ i.days }}天</div>
                <span :class="['flag', `flag${i.orderType}`]">{{ i.orderTypeStr }}({{i.statusStr}})</span>
            </el-tooltip>
            <!-- 试用/订购/赠送/后付款+到期时间 -->
            <el-tooltip placement="top" :open-delay="500" v-else-if="[0, 1, 5, 6].indexOf(i.orderType) > -1">
                <div slot="content">{{ i.endDay }}到期，剩余{{ i.days }}天</div>
                <span :class="['flag', `flag${i.orderType}`]">{{ i.orderTypeStr }}</span>
            </el-tooltip>
            <!-- 其他 -->
            <span :class="['flag', `flag${i.orderType}`]" v-else>{{ i.orderTypeStr }}</span>
          </div>
        </div>
        <div class="data-line">
          <div>有效期：{{ i.endDay }}</div>
          <!-- <div>最近一份合同：2022-1-1 至 2024-12-31</div> -->
          <!-- <div>当年试用时间：0个月</div> -->
          <div>最近一份合同：{{ i.latestContractModel ? i.latestContractModel.name : '' }}</div>
          <div>当年试用时间：</div>
        </div>
      </div>
      <div class="item-box placeholder" v-for="i in placeholderNum" :key="'p' + i"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    placeholderNum() {
      return this.dataList.length % 3 > 0 ? 3 - (this.dataList.length % 3) : 0;
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.main-content {
  display: flex;
  flex-wrap: wrap;
  gap: 21px 18px;
  .item-box {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0px 1px 0.75rem 1px rgba(4, 32, 93, 0.09);
    padding: 1.38rem;
    min-width: 20rem;
    box-sizing: border-box;
    flex: 1 1 calc(100% / 3 - 10px - 0.75rem);
    .msg-line-left {
      display: flex;
      align-items: center;
      padding-bottom: 1rem;
      margin-bottom: 1rem;
      border-bottom: 1px dashed #dddddd;
      font-weight: 550;
      .school-badge {
        width: 2em;
        height: 2em;
        border-radius: 50%;
        margin-right: 5px;
      }
      .school-name {
        color: #333333;
        margin-right: 1rem;
      }
      .line-right{
        margin-left: auto;
        .product-name{
          font-size: 0.95rem;
        }
      }

      .flag {
        border-radius: 3px;
        font-size: 0.86rem;
        padding: 0 5px;
        margin-left: 8px;
      }
      .flag1, .flag5 {
        background-color: #c6f4be;
        color: #37be1d;
      }
      .flag0 {
        background-color: #d1dfff;
        color: #4673da;
      }
        .flag2 {
            background-color: #fbd1ff;
            color: #da46d3;
        }
      .flag3 {
        background-color: #ffdad8;
        color: #e51205;
      }
        .flag4 {
            background-color: #4673da;
            color: #ffffff;
        }
        .flag6 {
            background-color: rgb(234, 212, 255);
            color: blueviolet;
        }
        .flag-red {
            background-color: #FFECE8;
            color: #F53F3F;
        }
    }
    .data-line {
      line-height: 2;
    }
  }
  /* 去除每行尾的多余边距 */
  .item-box:nth-child(3n) {
    margin-right: 0;
  }
  .placeholder {
    visibility: hidden;
  }
}
</style>
